import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteApprovalCreate,
  NoteApprovalCreateVariables,
} from './__generated__/NoteApprovalCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_APPROVAL_SETUP_CREATE from './NoteApprovalCreate.graphql';

type ApprovalSetupNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const ApprovalSetupNotesSection: React.FC<
  ApprovalSetupNotesSectionProps
> = ({ id, data, loading, listRefreshRequest }) => {
  return (
    <GenericNotesSection<
      any,
      NoteApprovalCreate, // TMutationResult
      NoteApprovalCreateVariables // TMutationVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_APPROVAL_SETUP_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
